import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {
	contextUser: null,
	permissions: null,
	additionalInfo: null,
	previousContextUser: null,
};

const userContextReducerMap = {
	[types.SET_CONTEXT_USER]: (state, action) => ({
		...state,
		contextUser: action.payload,
		previousContextUser: state.contextUser,
	}),

	[types.RESET_CONTEXT_USER]: () => {
		return initialState;
	},

	[types.PREVIOUS_CONTEXT_USER]: (state) => ({
		...state,
		contextUser: state.previousContextUser,
		previousContextUser: null,
	}),

	[types.SET_CONTEXT_USER_PERMISSIONS]: (state, { payload }) => ({
		...state,
		permissions: payload.permissions,
	}),

	[types.SET_CONTEXT_USER_ADDITIONAL_INFO]: (state, { payload }) => ({
		...state,
		additionalInfo: payload.additionalInfo,
	}),
};

export default handleActions(userContextReducerMap, initialState);
